import { FleetOptions } from "./fleet_options.model";
export class Fleet {
    start_date: string = '';
    end_date: string = '';
    years: number = null;
    claims: number = null;
    paid: any = new FleetOptions();
    outstanding: any = new FleetOptions();
    details: string = '';
}
